'use strict';

/**
 * window.fedops.apps wrapper (for tests mainly)
 */
function getAppData(appName) {
  return window.fedops.apps[appName];
}

export default {
  init(appName) {
    window.fedops.apps[appName] = window.fedops.apps[appName] || {};
  },

  getStartLoadTime(appName) {
    const appData = getAppData(appName);
    if (!appData) {
      return null;
    }
    return appData.startLoadTime;
  },

  setStartLoadTime(appName, startLoadTime) {
    return getAppData(appName).startLoadTime = startLoadTime;
  }
};



// WEBPACK FOOTER //
// ./app-data/app-data.js